import {A360ProductModel} from 'Quoting/models/Quoting';
import axios from 'Shared/utilities/axiosInstance';
import {getAxiosConfig, handleResponse} from 'Shared/utilities/fetchHelpers';

const getAxiosConfigAndHeaders = () => {
  const axiosConfig = getAxiosConfig();

  return {
    ...axiosConfig,
    headers: {
      ...axiosConfig.headers,
    },
  };
};

function getApiUrl(modelName: A360ProductModel, policyNumber: string, packageCd: string): string {
  const modelMapping: Record<A360ProductModel, string> = {
    [A360ProductModel.HIMaster]: 'hi-master',
    [A360ProductModel.CIMaster]: 'ci-master',
    [A360ProductModel.ACCMaster]: 'acc-master',
    [A360ProductModel.GPLUMaster]: 'gplu-master',
  };

  if (!modelMapping[modelName]) {
    throw new Error('Invalid model name');
  }

  const modelUrlPart = modelMapping[modelName];

  const endpoint = `api/policies/v1/${modelUrlPart}/${packageCd}/${policyNumber}/1/rating-details`;

  return endpoint;
}

const modelName: A360ProductModel = A360ProductModel.HIMaster;
export default {
  getRatingDetails: async (modelName: A360ProductModel, policyNumber: string, packageCd: string) => {
    const response = await axios.get<[]>(getApiUrl(modelName, policyNumber, packageCd), getAxiosConfigAndHeaders());
    return handleResponse(response);
  },
};
